import isEmpty from 'lodash/isEmpty';
import t from '@instructure/quiz-i18n/es/format-message';
export var presence = function presence(val, options) {
  var message = options.message || t('cannot be blank');

  // isEmpty treats whitespace as non-empty, so handle that separately
  if (isEmpty(val) || typeof val === 'string' && val.trim() === '') {
    return message;
  }
};
export default presence;